import useQuery from "hooks/useQuery";
import queryString from "query-string";
import { useEffect } from "react";
import { showErrorModal } from "utils";
import { getSeguros } from "./api";

const useSeguros = (precioId, modo, fechaAumento, origen) => {
  const esListaPrecios = origen !== "ACUERDOS";
  const modoHistorico = modo === 'historico';

  const { data, loading, refetch } = useQuery({
    autoFetch: false,
    queryFn: getSeguros,
    onError: (err) => showErrorModal({ err }),
  });

  const fetch = (precioId) => {
    const query = queryString.stringify({
      precioId,
      modo,
      fecha: fechaAumento,
      origen,
    });
    refetch(query);
  }

  useEffect(() => {
    if (!precioId) return;
    if (esListaPrecios) {
      if (modoHistorico && !fechaAumento) return;
      fetch(precioId);
    } else {
      fetch(precioId);
    }
    // if (!precioId) return;
    // if (origen !== "ACUERDOS" && (!modo && !fechaAumento)) return;
    // fetch(precioId);
  }, [precioId, modo, fechaAumento]);

  return {
    preciosSeguros: data?.data?.precios_seguros,
    loading,
    fetch,
  }
};

export default useSeguros;